import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT, LOGO, KOCHI } from "../mock";

export const MetroKochi = () => (
  <section className="py-20 md:py-24 bg-white">
    <div className="max-w-5xl mx-auto px-5 md:px-8">
      <div className="bg-gradient-to-br from-[#0f2e2b] to-[#134640] rounded-3xl p-10 md:p-14 text-center">
        <div className="bg-white rounded-2xl inline-block px-6 py-4 mb-7">
          <img
            src={KOCHI.logo}
            alt="Morning Star Metro Home Stay Kochi"
            className="h-14 md:h-16 w-auto object-contain"
          />
        </div>
        <p className="text-[#25d3c4] text-xs font-semibold tracking-[0.25em] uppercase mb-4">
          New Property
        </p>
        <h2 className="text-2xl md:text-4xl font-extrabold text-white mb-6">
          Morning Star Metro Home Stay Kochi
        </h2>
        <p className="text-neutral-300 leading-8 max-w-3xl mx-auto mb-4">
          Auracrest Haven Resorts proudly presents “Morning Star Metro Home Stay Kochi” — a new
          property in the heart of Kochi City! An urban oasis perfectly blending the warmth of
          traditional hospitality with contemporary comfort.
        </p>
        <p className="text-[#25d3c4] font-medium mb-8">
          NB: Avail special discounts for guests using both properties at Kochi &amp; Munnar!
        </p>
        <Link
          to="/morning_star_metro_home_stay_kochi"
          className="inline-flex items-center gap-2 bg-[#25d3c4] hover:bg-[#1cc0b2] text-[#0f2e2b] font-semibold px-8 py-3 rounded-md transition-colors"
        >
          Show More <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  </section>
);

export const Footer = () => (
  <footer className="bg-[#0b1f1d] text-neutral-400 py-12">
    <div className="max-w-7xl mx-auto px-5 md:px-8 grid md:grid-cols-3 gap-8">
      <div>
        <div className="bg-white rounded-xl inline-block px-4 py-3 mb-4">
          <img src={LOGO} alt="Auracrest Haven" className="h-12 w-auto object-contain" />
        </div>
        <p className="text-sm leading-7">
          A luxury homestay near Sengulam Dam in Munnar, surrounded by lush cardamom and nutmeg
          plantations.
        </p>
      </div>
      <div>
        <h4 className="text-white font-semibold mb-4">Contact</h4>
        <p className="text-sm leading-7">{CONTACT.address}</p>
        <p className="text-sm mt-2">{CONTACT.phone}</p>
        <p className="text-sm">{CONTACT.email}</p>
      </div>
      <div>
        <h4 className="text-white font-semibold mb-4">Quick Links</h4>
        <ul className="space-y-2 text-sm">
          <li><a href="#about" className="hover:text-[#25d3c4] transition-colors">About</a></li>
          <li><a href="#dining" className="hover:text-[#25d3c4] transition-colors">Dining</a></li>
          <li><a href="#attractions" className="hover:text-[#25d3c4] transition-colors">Attractions</a></li>
          <li><a href="#contact" className="hover:text-[#25d3c4] transition-colors">Contact</a></li>
          <li>
            <Link to="/morning_star_metro_home_stay_kochi" className="hover:text-[#25d3c4] transition-colors">
              Morning Star Metro Home Stay Kochi
            </Link>
          </li>
          <li>
            <a
              href="https://www.finediningmunnar.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#25d3c4] transition-colors"
            >
              SpyzzZ Fine Dining Munnar
            </a>
          </li>
          <li>
            <a
              href="https://spyzzie.in"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#25d3c4] transition-colors"
            >
              Spyzzie Food Delivery
            </a>
          </li>
          <li>
            <a href="/privacy_policy.html" className="hover:text-[#25d3c4] transition-colors">
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-5 md:px-8 mt-10 pt-6 border-t border-white/10 text-sm text-center">
      © {new Date().getFullYear()} Auracrest Haven, Munnar. All rights reserved.
    </div>
  </footer>
);
